import type { AnalysisState } from '@aibi/contracts';

/** Motivos estables por los que una operacion se rechaza sin modificar el estado. */
export type RejectionCode =
  | 'unknown-card'
  | 'unknown-field'
  | 'duplicate-field'
  | 'kind-mismatch'
  | 'invalid-filter'
  | 'invalid-state'
  | 'invalid-move'
  | 'limit-reached'
  | 'no-hierarchy'
  | 'unsupported-drop'
  | 'stale-proposal';

export interface Rejection {
  readonly code: RejectionCode;
  readonly message: string;
}

export type StepResult = { readonly ok: true; readonly state: AnalysisState } | RejectedStep;

export interface RejectedStep {
  readonly ok: false;
  readonly rejection: Rejection;
}

export const reject = (code: RejectionCode, message: string): RejectedStep => ({
  ok: false,
  rejection: { code, message },
});

export const accept = (state: AnalysisState): StepResult => ({ ok: true, state });
